import {connect} from 'react-redux';
import AvailabilityComponent from "../components/AvailabilityComponent";
import {showState} from "../actions/AvailabilityActions";
import AvailabilityMobileComponent from "../components/mobile/AvailabilityMobileComponent";

const mapStateToProps = state => {
  return {
    // displayAvailability: (state.availabilityReducer.availability.properties.length > 0),
    // property: (state.availabilityReducer.availability.properties.length > 0 ? state.availabilityReducer.availability.properties[0] : {name: ''}),
    // properties: state.availabilityReducer.availability.properties,
    processing: state.availabilityReducer.processing,
    criteria: state.availabilityReducer.criteria,
    properties: state.availabilityReducer.properties,
    // showState: state.availabilityReducer.showState,
    // state: state.availabilityReducer
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onShowStateClick: (show) => {
      dispatch(showState(show));
    }
  }
};

export const Availability = connect(mapStateToProps, mapDispatchToProps) (AvailabilityComponent);
export const AvailabilityMobile = connect(mapStateToProps, mapDispatchToProps) (AvailabilityMobileComponent);



// WEBPACK FOOTER //
// ./src/containers/Availability.js